import { isDspV3Enabled, DSP_VERIFY_REDIRECTING, DSP_SESSION_IN_COOKIE, getDspGeneration, shouldStopDspResponse } from './dsp';

export const startApp = (renderApp, authenticate, showFailure) => {
	const enabled = isDspV3Enabled();
	const started = getDspGeneration();
	if (!enabled) {
		renderApp();
		const handleLegacyResponse = response => {
			if (response !== DSP_SESSION_IN_COOKIE && response !== 'BEARER_TOKEN_IN_SESSION_STORAGE') {
				try {
					sessionStorage.setItem('tokenStatus', response);
				} catch (error) {
					// Storage is optional; do not prevent the already-rendered app.
				}
				console.error('Unable to authenticate ESG session.');
			}
		};
		const handleLegacyFailure = () => handleLegacyResponse('DSP_AUTHENTICATION_FAILED');
		try {
			return Promise.resolve(authenticate()).then(handleLegacyResponse, handleLegacyFailure);
		} catch (error) {
			handleLegacyFailure();
			return Promise.resolve();
		}
	}
	return Promise.resolve().then(() => authenticate()).then(response => {
		if (response === DSP_VERIFY_REDIRECTING || shouldStopDspResponse(started)) {
			return;
		}
		if (response !== DSP_SESSION_IN_COOKIE && response !== 'BEARER_TOKEN_IN_SESSION_STORAGE') {
			throw new Error('Authentication did not establish a session.');
		}
		renderApp();
	}).catch(error => {
		if (shouldStopDspResponse(started)) {
			return;
		}
		// Do not persist raw network errors, tokens, or login redirect sentinels.
		try {
			sessionStorage.setItem('tokenStatus', 'DSP_AUTHENTICATION_FAILED');
		} catch (error) {
			// Blocked storage must not produce an unhandled startup rejection.
		}
		console.error('Unable to authenticate ESG session.');
		showFailure(error);
	});
};